import { setSessionTokenOverride } from "@birdwatch/client";

import {
  getImpersonationToken,
  isImpersonationFrame,
  requestSessionFromHost,
} from "./_hooks/impersonation-frame-session";

/**
 * Run before the React tree renders. In an ordinary document this is a no-op.
 * In the impersonation frame it completes the handshake with the host and
 * installs the actor token as the session token for every platform request,
 * so the very first request — `GET /auth/me`, which decides the portal's
 * identity and role gates — already resolves as the impersonated user.
 *
 * Rejects when the host does not answer or refuses; the caller decides what
 * to render instead of the app. Booting the portal anyway would silently show
 * the admin's own account inside a frame labelled as someone else.
 */
export async function bootImpersonationFrame(): Promise<void> {
  if (!isImpersonationFrame()) return;

  await requestSessionFromHost();
  setSessionTokenOverride(getImpersonationToken);
}
